import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, } from "firebase/firestore";

import { db } from '../../firebase'
import { Link } from "react-router-dom";


import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

import ScrollToTop from "react-scroll-to-top";

import {
  FacebookShareButton, WhatsappShareButton, WhatsappIcon,
  FacebookIcon, TwitterShareButton, EmailShareButton, EmailIcon,

  LinkedinShareButton,
  LinkedinIcon,
  TwitterIcon,
} from "react-share";
import Header from '../inc/Header';

function Litter() {
    


   const phoneNumber = "918927119640"; // Replace with your number (with country code, no +)
  const message = "Hello..";

  const encodedMessage = encodeURIComponent(message);
  const whatsappURL = `https://wa.me/${918927119640}?text=${encodedMessage}`;


  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  const [setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showPerPage, setShowPerPage] = useState(400);
  const [pagination, setPagination] = useState({
    start: 0,
    end: showPerPage,
  });

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };
  const [searchTerm, setsearchTerm] = useState("");
  const [ring, setRing] = useState([])
  const navigate = useNavigate()

  const ringCollectionRef = collection(db, "Litter");
  useEffect(() => {

    const getRing = async () => {
      const data = await getDocs(ringCollectionRef);
      setRing(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
    }

    getRing()
  }, [])
  return (
    

    <>
      <Header/>

      <br />




      <ScrollToTop smooth top="100" color="maroon" />

      <br />
      <br />
      <br />

      
            <div className='goldberhampore'>
              <div className="album py-1">
                <div className="container mt-4">
                  <div className="row">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li style={{ color: "maroon" }} className="breadcrumb-item"><Link style={{ color: "maroon" }} to="/" > <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-left" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                          <path fill-rule="evenodd" d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                        </svg> Home</Link></li>
      
                        <li className="breadcrumb-item active" aria-current="page">Litter</li>
      
                      </ol>
                    </nav>
                  </div>
      
                </div>
              </div>
            </div>


      <div className="album py-1">

        <div className="container">

          <div className="row">

            <div className="col-md-6">

              <div className="card-body">
                <input type="text" className="form-control" placeholder="Search" name="location"
                  onChange={(e) => {
                    setsearchTerm(e.target.value);
                  }}
                />
                <div className="d-flex justify-content-between align-items-center">




                </div>


              </div>


            </div>

          </div>

        </div>
      </div>
      <div className="album py-1">

        <div className="container">

          <div className="row">
            {ring.filter((val) => {
              if (setsearchTerm === "") {
                return val;
              } else if (
                val.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                val.des.toLowerCase().includes(searchTerm.toLowerCase())



              ) {
                return val;
              }
            }).slice(pagination.start, pagination.end).map((petplazza) => {
              return (

                <div className="col-md-4 mt-2" >
                  <div className="card mb-4">
                       <h4 className='btn-grad84'>{petplazza.kg} </h4>
                    <Zoom>

                      <img className="card-img-top" src={petplazza.img} alt={petplazza.title}/>
                    </Zoom>
                    <div className="card-body">

                      <h6 style={{color:"#CC000A"}} className="card-text"> <b>{petplazza.title}</b></h6>

                      <p className="card-text mb-2"><small>{petplazza.des}</small></p>
                      <p style={{color: "Gray"}}className="card-text mb-2"> M.R.P.: <del> ₹{petplazza.mrp}</del> </p>
                      <button className='btn btn-outline-danger btn-sm mb-2'>{petplazza.off}%OFF</button>
                      <h6 className="card-text" >₹{petplazza.price}   </h6>
 <p className="card-text mb-2">{petplazza.benifit}</p>
                      <div className="d-flex justify-content-between align-items-center">

                        <a href='tel: 8927119640'> <p className="healthpetproducts mt-3">Call Book</p></a>
<a href={whatsappURL} target="_blank" rel="noopener noreferrer">
                    <button style={{ padding: "4px 12px", backgroundColor: "#1B8755", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" }}>
                     <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
  <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
</svg>
                    </button>
                  </a>          </div>
                      <button type="button" className="btn btn btn-dark me-1">
                        Share  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-share-fill" viewBox="0 0 16 16">
                          <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z" />
                        </svg>
                      </button> < FacebookShareButton url="https://www.thepetplazza.com/litter" className="me-2" quote={"M B Dhar and Son Jewellers"} hastag={"#WebApp"}
                      >
                        <FacebookIcon size={37} round={true} />
                      </FacebookShareButton>

                      <  WhatsappShareButton url="https://www.thepetplazza.com/litter" className="me-2" quote={"M B Dhar and Son Jewellers"} hastag={"#WebApp"}
                      >
                        <WhatsappIcon size={37} round={true} />
                      </ WhatsappShareButton>

                      <  TwitterShareButton url="https://www.thepetplazza.com/litter" className="me-2" quote={"M B Dhar and Son Jewellers"} hastag={"#WebApp"}
                      >
                        <TwitterIcon size={37} round={true} />
                      </ TwitterShareButton>

                      <  LinkedinShareButton url="https://www.thepetplazza.com/litter" className="me-2" quote={"M B Dhar and Son Jewellers"} hastag={"#WebApp"}
                      >
                        <  LinkedinIcon size={37} round={true} />
                      </ LinkedinShareButton>

                      <  EmailShareButton url="https://www.thepetplazza.com/litter" quote={"M B Dhar and Son Jewellers"} hastag={"#WebApp"}
                      >
                        <  EmailIcon size={37} round={true} />
                      </ EmailShareButton>
                      <div className="d-flex justify-content-between align-items-center">



                      </div>
                    </div>
                  </div>

                </div>
              )
            })}
          </div>
         
        </div>
      </div>

    </>

  );
}

export default Litter;